<template>
  <TransitionTemplate
    transition="slideUp"
    :loading="loading"
    :conditional="items.length ? true : false"
  >
    <v-container class="position-relative">
      <div class="d-flex align-center justify-end view-changer">
        <v-btn
          @click="setViewMode()"
          class="text-none cursor-pointer"
          :fab="xsOnly"
          :small="xsOnly"
          text
        >
          <v-icon color="primary" size="20" :left="!xsOnly">
            {{ viewMode == 0 ? "fa-th-large" : "fa-list" }}
          </v-icon>

          <span v-if="!xsOnly" class="primary--text text-body-1">
            Modo de Visualização
          </span>
        </v-btn>
      </div>

      <template v-for="(list, category) in itemsByCategory">
        <div
          :key="formatToURL(category)"
          class="pt-3 pt-md-10"
          :id="formatToURL(category)"
        >
          <TitleWidget class="font-weight-bold">
            {{ category }}
          </TitleWidget>

          <div
            class="justify-center pt-3 pt-md-6 products-grid-list"
            :class="{
              'alternative-view-mode': viewMode == 1,
              'mx-n3 mx-md-0': viewMode == 0,
            }"
          >
            <template v-for="item in list">
              <ProductCard v-if="viewMode == 0" :key="item.id" v-bind="item" />
              <ProductAlternativeCard v-else :key="item.id" v-bind="item" />
            </template>
          </div>
        </div>
      </template>
    </v-container>
  </TransitionTemplate>
</template>

<script>
import TransitionTemplate from "../templates/TransitionTemplate.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import ProductCard from "../cards/ProductCard.vue";
import ProductAlternativeCard from "../cards/ProductAlternativeCard.vue";
import groupBy from "lodash.groupby";
import { formatToURL } from "../../utils/formatToURL";
import { searchTest } from "../../utils/searchTest";

const _config = {
  mod: "products",
  path: "/p",
};

export default {
  data: () => ({
    loading: true,
    viewMode: 0,
  }),
  created() {
    const config = this.$rest("config").get({
      save: (state, data) => (state.item = data),
    });

    const products = this.$rest(_config.mod).get();

    Promise.all([config, products]).finally(() => (this.loading = false));

    const viewMode = ["Horizontal", "Vertical"];

    this.viewMode =
      localStorage.getItem("viewMode") ||
      Object.keys(viewMode)[
        Object.values(viewMode).indexOf(this.config.view_mode.title)
      ];
  },
  computed: {
    items() {
      const items = this.$rest(_config.mod).list;
      const search = this.$route.query.q;

      if (search) {
        return items.filter(({ title, text }) => {
          return searchTest(search, title) || searchTest(search, text);
        });
      }

      return items;
    },
    itemsByCategory() {
      return groupBy(
        this.items.map(
          ({ id, img, title, subtitle, price, variants, category, text }) => ({
            id,
            img: img.featured,
            title,
            subtitle,
            price: variants.length
              ? variants.reduce((item, currentItem) => {
                  return !!currentItem &&
                    Number(currentItem.price) < Number(item.price)
                    ? currentItem
                    : item;
                }).price
              : price,
            variants,
            category: category.title,
            text,
            to: `${_config.path}/${formatToURL(title)}-${id}`,
          })
        ),
        "category"
      );
    },
    config() {
      return this.$rest("config").item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    setViewMode() {
      this.viewMode = this.viewMode == 0 ? 1 : 0;

      localStorage.setItem("viewMode", this.viewMode);
    },
    formatToURL,
  },
  components: {
    TransitionTemplate,
    TitleWidget,
    ProductCard,
    ProductAlternativeCard,
  },
};
</script>

<style lang="scss" scoped>
.view-changer {
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 56px;

  @media screen and (max-width: 960px) {
    top: 20px;
  }

  .v-btn {
    pointer-events: initial;
  }
}
</style>
